import { StyledEngineProvider } from '@mui/material/styles'
import { LoadingProvider } from 'context/LoadingContext'
import { ModalProvider } from 'context/ModalContext'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import 'react-phone-input-2/lib/style.css'

import Routes from './navigation/routes'
import configureStore from './store'

import 'reset.css'
import Dexie from 'dexie'

import { useEffect } from 'react'

const { store, persistor } = configureStore()

export default function App() {
  useEffect(() => {
    Dexie.delete('ReportsDatabase')
  }, [])

  return (
    <Provider store={store}>
      <StyledEngineProvider injectFirst>
        <PersistGate loading={null} persistor={persistor}>
          <LoadingProvider>
            <ModalProvider>
              <Routes />
            </ModalProvider>
          </LoadingProvider>
        </PersistGate>
      </StyledEngineProvider>
    </Provider>
  )
}
